"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTenantSessionStorage = exports.getTenantSessionStorage = void 0;
const constants_1 = require("./constants");
exports.getTenantSessionStorage = () => JSON.parse(sessionStorage.getItem(constants_1.SESSION_TENANT_KEY)) || {};
exports.setTenantSessionStorage = (tenant) => sessionStorage.setItem(constants_1.SESSION_TENANT_KEY, JSON.stringify(tenant));
